import { CarrierDto, KnownSortOrder, KnownUserStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { isCarrierProjectType } from '../../../../app/navigation/courier-project-type';

/** The roster: on the books and awaiting approval, which is what this page is for. */
export const CARRIER_COURIER_STATUS_WORKING = 'working';

/** Every status the page offers, `deleted` excepted. */
export const CARRIER_COURIER_STATUS_ALL = 'all';

/** What each option sends. The endpoint takes several statuses, so these need no widening. */
export const CarrierCourierStatusFilters: Record<string, KnownUserStatus[]> = {
  [CARRIER_COURIER_STATUS_WORKING]: [KnownUserStatus.Active, KnownUserStatus.Pending],
  [CARRIER_COURIER_STATUS_ALL]: [KnownUserStatus.Active, KnownUserStatus.Pending, KnownUserStatus.Inactive]
};

export type CarrierCouriersControlsState = {
  sortBy: string;
  sortOrder: KnownSortOrder;
  status: string;
};

/**
 * No `deleted` — the page is the carrier's working roster. No `incomplete` either; it only ever
 * applies to a courier still in the phone-verification groups.
 */
export const CarrierCourierStatusOptions = [
  { label: 'Active & Pending', value: CARRIER_COURIER_STATUS_WORKING },
  { label: 'Active, Pending & Inactive', value: CARRIER_COURIER_STATUS_ALL },
  { label: 'Active Only', value: KnownUserStatus.Active },
  { label: 'Pending Only', value: KnownUserStatus.Pending },
  { label: 'Inactive Only', value: KnownUserStatus.Inactive }
];

/**
 * The project a carrier's couriers are listed under: its managing project where it has one (a
 * region's), else the project its container is attached to (a pool's network). Not the page's —
 * the endpoint matches couriers on that exact project, and a site holds none, so a carrier opened
 * from one listed nothing. Undefined where the carrier names neither.
 */
export function carrierCouriersScopeProjectID(
  carrier: Pick<CarrierDto, 'managedBy' | 'container'>
): string | undefined {
  return carrier.managedBy?.id || carrier.container?.project?.id;
}

/**
 * The project a carrier's capabilities are scoped to. A network or site asks what it may do there.
 * A carrier or region project is where the carrier is managed from, not where it works, so nothing
 * is granted in its scope — it asks for everywhere the carrier works instead (undefined).
 */
export function carrierCapabilitiesScopeProjectID(pageProjectID: string, pageProjectType?: string): string | undefined {
  return isCarrierProjectType(pageProjectType) ? undefined : pageProjectID;
}
